export default __webpack_public_path__ + "static/media/DSC_0824.26dffb5e.JPG";